/**
 * The external dependecies
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormCreateCourseUnit from "components/form/FormCreateCourseUnit";

/**
 * @class      ModalCreateCourse (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalCreateCourse = (props) => {
  return (
    <ModalFrame>
      <FormCreateCourseUnit />
    </ModalFrame>
  );
};

export default ModalCreateCourse;
